import { cva } from "class-variance-authority";

export const radioStyles = cva(
  "flex border rounded-[12px] cursor-pointer p-4 items-start",
  {
    variants: {
      variant: {
        default: "bg-white border-appcolorfaintnine",
        selected: "bg-primary50 border-[2px] border-primary500",
      },
    },
  }
);
